import { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import { itinerariesItemDataSelector } from 'store/itinerariesItem/selectors';
import { updateItinerariesItemThunk } from 'store/itinerariesItem/thunks';
import { pageDataSelector } from 'store/page/selectors';
import { savePageThunk } from 'store/page/thunks';
import { isAgentSelector } from 'store/user/selectors';
import { confirmAlert } from 'utils/alert';
import { isSample } from 'utils/itineraries/functions';

function useFormLayout({ type }) {
  const dispatch = useDispatch();
  const { libType } = useParams();
  const [loading, setLoading] = useState(true);
  const currentPage = useSelector(pageDataSelector);
  const currentSample = useSelector(itinerariesItemDataSelector);
  const isAgent = useSelector(isAgentSelector);
  const isShowAlert = type === 'page' && currentPage?.status === 'approved' && !currentPage?.firstViewed && !isAgent;
  const isSampleProposal = isSample(libType) && type === 'itinerariesItem';
  const isShowAlertForSample = isSampleProposal && currentSample?.approved && !currentSample?.firstViewed && !isAgent;
  const itemType = isSampleProposal ? 'sample' : 'page';

  const onShowFirstViewAlert = () => {
    confirmAlert({
      title: 'Newly Approved Content.',
      onConfirm: () => null,
      hintBottom: `Congratulations! This ${itemType} is now live in our Safari Portal content library. Please be mindful that all changes made from this point on will be reflected site-wide.`,
      confirmButtonText: 'Okay',
      showCancel: false,
    });
  };

  useEffect(() => {
    if (isShowAlert) {
      async function alertFn() {
        const data = { id: currentPage?.id, firstViewed: true };
        await dispatch(savePageThunk(data));
        onShowFirstViewAlert();
        setLoading(false);
      }

      alertFn();
    } else if (isShowAlertForSample) {
      async function sampleAlertFn() {
        await dispatch(updateItinerariesItemThunk(currentSample?.id, { firstViewed: true }));
        onShowFirstViewAlert();
        setLoading(false);
      }

      sampleAlertFn();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { loading };
}

export default useFormLayout;
